document.addEventListener('DOMContentLoaded', () => {
  const PARTS = {
    M14: {
      vz: 53869496336730,
      v2a: 53869496369498,
      v4a: 53869496402266
    },
    M74: {
      vz: 53869499810138,
      v2a: 53869499842906,
      v4a: 53869499875674
    },
    T4: {
      vz: 53869504004442,
      v2a: 53869504037210,
      v4a: 53869504069978
    },
    T25: {
      v2a: 53874037850458,
      v4a: 53874037883226
    },
    T29: {
      vz: 53869551124826,
      v2a: 53869551157594,
      v4a: 53869551190362
    },
    DIN912_70: {
      v4a: 53869519110490
    },
    DIN912_80: {
      vz: 53869509869914,
      v2a: 53869509902682,
      v4a: 53869509935450
    },
    DIN912_100: {
      v4a: 53869524255066
    },
    DIN933_70: {
      vz: 53869539098970,
      v2a: 53869539131738,
      v4a: 53869539164506
    },
    DIN933_80: {
      vz: 53869528547674,
      v2a: 53869528580442,
      v4a: 53869528613210
    },
    DIN933_100: {
      vz: 53869534642522,
      v4a: 53869534708058
    },
    U36: {
      vz: 53869542637914,
      v2a: 53869542670682,
      v4a: 53869542703450
    },
    U46: {
      vz: 53874552734042,
      v2a: 53869550403930,
      v4a: 53869550436698
    },
    U40: {
      vz: 53869571539290,
      v2a: 53869571572058,
      v4a: 53869571604826
    },
    NUT_M8: {
      vz: 53872110797146,
      v2a: 53872110829914,
      v4a: 53872110862682
    },
    SPAX_80: {
      v2a: 53869554008410
    },
    SPAX_100: {
      v2a: 53869554532698
    }
  };

  const PART_TO_HANDLE = {
    M14: 'm-klammer-nr-14',
    M74: 'm-klammer-nr-74',
    T4: 'teller-nr-4',
    T25: 'teller-nr-25',
    T29: 'teller-nr-29',
    DIN912_70: 'schraube-m8x70-din-912',
    DIN912_80: 'schraube-m8x80-din-912',
    DIN912_100: 'schraube-m8x100-din-912',
    DIN933_70: 'schraube-m8x70-din-933',
    DIN933_80: 'schraube-m8x80-din-933',
    DIN933_100: 'schraube-m8x100-din-933',
    U36: 'klemmunterteil-nr-36',
    U46: 'klemmunterteil-nr-46',
    U40: 'doppelklemme-nr-40',
    NUT_M8: 'vierkantmutter-m8',
    SPAX_80: 'tellerkopf-bohrschraube-8x80',
    SPAX_100: 'tellerkopf-bohrschraube-8x100'
  };

  const PRODUCT_TITLES = window.GR_PRODUCT_TITLES || {};
  const VARIANT_INVENTORY = window.GR_VARIANT_INVENTORY || {};

  const TOP_LABELS = {
    M14: PRODUCT_TITLES.M14 || 'M-Klammer Nr. 14',
    M74: PRODUCT_TITLES.M74 || 'M-Klammer Nr. 74',
    T4: PRODUCT_TITLES.T4 || 'Teller Nr. 4',
    T25: PRODUCT_TITLES.T25 || 'Teller Nr. 25',
    T29: PRODUCT_TITLES.T29 || 'Teller Nr. 29'
  };

  const PART_LABELS = {
    M14: PRODUCT_TITLES.M14 || 'M-Klammer Nr. 14',
    M74: PRODUCT_TITLES.M74 || 'M-Klammer Nr. 74',
    T4: PRODUCT_TITLES.T4 || 'Teller Nr. 4',
    T25: PRODUCT_TITLES.T25 || 'Teller Nr. 25',
    T29: PRODUCT_TITLES.T29 || 'Teller Nr. 29',
    U36: PRODUCT_TITLES.U36 || 'Klemmunterteil Nr. 36',
    U46: PRODUCT_TITLES.U46 || 'Klemmunterteil Nr. 46',
    U40: PRODUCT_TITLES.U40 || 'Doppelklemme Nr. 40',
    NUT_M8: PRODUCT_TITLES.NUT_M8 || 'Vierkantmutter M8',
    SPAX_80: PRODUCT_TITLES.SPAX_80 || 'Tellerkopf-Bohrschraube 8x80',
    SPAX_100: PRODUCT_TITLES.SPAX_100 || 'Tellerkopf-Bohrschraube 8x100',
    DIN912_70: PRODUCT_TITLES.DIN912_70 || 'DIN 912 Schraube M8x70',
    DIN912_80: PRODUCT_TITLES.DIN912_80 || 'DIN 912 Schraube M8x80',
    DIN912_100: PRODUCT_TITLES.DIN912_100 || 'DIN 912 Schraube M8x100',
    DIN933_70: PRODUCT_TITLES.DIN933_70 || 'DIN 933 Schraube M8x70',
    DIN933_80: PRODUCT_TITLES.DIN933_80 || 'DIN 933 Schraube M8x80',
    DIN933_100: PRODUCT_TITLES.DIN933_100 || 'DIN 933 Schraube M8x100'
  };

  const grEmbed = document.querySelector('.gitterrost-konfigurator-embed');

  const MATERIAL_LABELS = {
    vz: grEmbed?.dataset?.i18nMaterialVz || 'Verzinkt',
    v2a: grEmbed?.dataset?.i18nMaterialV2a || 'V2A',
    v4a: grEmbed?.dataset?.i18nMaterialV4a || 'V4A'
  };

  const FIX_LABELS = {
    klemme: grEmbed?.dataset?.i18nFixKlemme || 'Klemmbefestigung',
    doppelklemme: grEmbed?.dataset?.i18nFixDoppelklemme || 'Doppelklemme',
    holz_stellfuesse: grEmbed?.dataset?.i18nFixHolz || 'Holz / Stellfüße'
  };

  const CONFIG = {
    ISO14_13x13: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO15_44x44: {
      length: 70,
      topOptions: ['M14', 'T4', 'T29'],
      bohrTopOptions: ['T4', 'T29'],
      unterteilKlemme: 'U36',
      unterteilDoppelklemme: 'U40'
    },

    ISO25_31x31: {
      length: 70,
      topOptions: ['M74', 'T4', 'T29'],
      bohrTopOptions: ['T4', 'T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO25_13x13: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO30_31x31: {
      length: 70,
      topOptions: ['M74', 'T4', 'T29'],
      bohrTopOptions: ['T4', 'T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO30_14x14: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO30_8x8: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO30SWL_28x28: {
      length: 70,
      topOptions: ['M74', 'T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO35SWL_28x28: {
      length: 70,
      topOptions: ['M74', 'T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO38_13x13: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO38_31x31: {
      length: 70,
      topOptions: ['M74', 'T4', 'T29'],
      bohrTopOptions: ['T4', 'T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO50_42x42: {
      length: 80,
      topOptions: ['M14', 'T4', 'T29'],
      bohrTopOptions: ['T4', 'T29'],
      unterteilKlemme: 'U36',
      unterteilDoppelklemme: 'U40'
    },

    ISO50_17x17: {
      length: 80,
      topOptions: ['T25', 'T29'],
      bohrTopOptions: ['T25', 'T29'],
      unterteilKlemme: 'U36',
      unterteilDoppelklemme: 'U40'
    },

    ISO50SWL_26x26: {
      length: 80,
      topOptions: ['M74', 'T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    ISO60SWL_26x26: {
      length: 80,
      topOptions: ['M74', 'T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    P15_31x31: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    P25_31x31: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    P30_31x31: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    P38_31x31: {
      length: 70,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    P50_42x42: {
      length: 80,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U36',
      unterteilDoppelklemme: 'U40'
    },

    P50SWL_26x26: {
      length: 80,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    },

    P60SWL_26x26: {
      length: 80,
      topOptions: ['T29'],
      bohrTopOptions: ['T29'],
      unterteilKlemme: 'U46',
      unterteilDoppelklemme: 'U40'
    }
  };

  const TYPE_TO_MESHES = {
    ISO14: ['13x13'],
    ISO15: ['44x44'],
    ISO25: ['31x31', '13x13'],
    ISO30: ['31x31', '14x14', '8x8'],
    ISO30SWL: ['28x28'],
    ISO35SWL: ['28x28'],
    ISO38: ['13x13', '31x31'],
    ISO50: ['42x42', '17x17'],
    ISO50SWL: ['26x26'],
    ISO60SWL: ['26x26'],
    P15: ['31x31'],
    P25: ['31x31'],
    P30: ['31x31'],
    P38: ['31x31'],
    P50: ['42x42'],
    P50SWL: ['26x26'],
    P60SWL: ['26x26']
  };

  const I18N = {
    choose: grEmbed?.dataset?.i18nChoose || 'Bitte wählen',
    selectTypeFirst: grEmbed?.dataset?.i18nSelectTypeFirst || 'Bitte zuerst Gitterrost wählen',
    selectMeshFixFirst: grEmbed?.dataset?.i18nSelectMeshFixFirst || 'Bitte zuerst Masche und Montageart wählen',
    selectTopFirst: grEmbed?.dataset?.i18nSelectTopFirst || 'Bitte zuerst Oberteil wählen',
    noTop: grEmbed?.dataset?.i18nNoTop || 'Keine Oberteile verfügbar',
    notAvailable: grEmbed?.dataset?.i18nNotAvailable || 'Nicht verfügbar',
    selectConfiguration: grEmbed?.dataset?.i18nSelectConfiguration || 'Bitte Konfiguration vollständig auswählen.',
    qtyLabel: grEmbed?.dataset?.i18nQtyLabel || 'Menge',
  
    loadingPrices: grEmbed?.dataset?.i18nLoadingPrices || 'Preise werden geladen …',
    article: grEmbed?.dataset?.i18nArticle || 'Artikel',
    qtyShort: grEmbed?.dataset?.i18nQtyShort || 'Menge',
    totalLabel: grEmbed?.dataset?.i18nTotalLabel || 'Gesamt'
  };

  const typeEl = document.getElementById('gr-type');
  const meshEl = document.getElementById('gr-mesh');
  const fixEl = document.getElementById('gr-fix');
  const topEl = document.getElementById('gr-top');
  const materialEl = document.getElementById('gr-material');
  const qtyEl = document.getElementById('gr-qty');
  const addEl = document.getElementById('gr-add');
  const msgEl = document.getElementById('gr-message');
  const availabilityEl = document.getElementById('gr-availability');

  if (!typeEl || !meshEl || !fixEl || !topEl || !materialEl || !qtyEl || !addEl || !msgEl) {
    return;
  }

  const variantIndex = {};
  const productIndex = {};
  let pricesLoaded = false;
  let priceLoadFailed = false;

  let previewMediaHost = null;
  let previewMediaOriginalChildren = [];

  const currencyCode =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'EUR';

  const moneyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: currencyCode
  });

  function formatMoney(cents) {
    return moneyFormatter.format((cents || 0) / 100);
  }

  function showMessage(text, isError = false) {
    msgEl.textContent = text;
    msgEl.style.color = isError ? 'red' : 'green';
  }

  function resetSelect(selectEl, placeholder) {
    selectEl.innerHTML = '';
    const option = document.createElement('option');
    option.value = '';
    option.textContent = placeholder;
    selectEl.appendChild(option);
  }

  function getRule() {
    const type = typeEl.value;
    const mesh = meshEl.value;
    if (!type || !mesh) return null;
    return CONFIG[`${type}_${mesh}`] || null;
  }

  function getPartId(partKey, material) {
    const part = PARTS[partKey];
    if (!part) return null;
    return part[material] || null;
  }

  function getScrewKey(selectedTop, length) {
    if (selectedTop === 'M14' || selectedTop === 'M74') {
      return `DIN912_${length}`;
    }
    return `DIN933_${length}`;
  }

  function getBohrKey(length) {
    return length === 80 ? 'SPAX_100' : 'SPAX_80';
  }

  function getAvailableTopOptions(rule, fix) {
    if (!rule || !fix) return [];
    if (fix === 'holz_stellfuesse') {
      return rule.bohrTopOptions || [];
    }
    return rule.topOptions || [];
  }

  function getAvailableMaterials(rule, fix, selectedTop) {
    if (!rule || !fix || !selectedTop) return [];

    const materialKeys = ['vz', 'v2a', 'v4a'];

    return materialKeys.filter((material) => {
      if (fix === 'holz_stellfuesse') {
        const topId = getPartId(selectedTop, material);
        const bohrId = getPartId(getBohrKey(rule.length), material);
        return Boolean(topId && bohrId);
      }

      const topId = getPartId(selectedTop, material);
      const screwId = getPartId(getScrewKey(selectedTop, rule.length), material);
      const nutId = getPartId('NUT_M8', material);
      const underId =
        fix === 'klemme'
          ? getPartId(rule.unterteilKlemme, material)
          : getPartId(rule.unterteilDoppelklemme, material);

      return Boolean(topId && screwId && nutId && underId);
    });
  }

  function updateMeshes() {
    showMessage('');

    const type = typeEl.value;

    resetSelect(meshEl, type ? I18N.choose : I18N.selectTypeFirst);
    meshEl.disabled = !type;

    resetSelect(topEl, I18N.selectMeshFixFirst);
    topEl.disabled = true;

    resetSelect(materialEl, I18N.selectTopFirst);
    materialEl.disabled = true;

    if (!type) {
      renderAll();
      return;
    }

    const meshes = TYPE_TO_MESHES[type] || [];
    meshes.forEach((mesh) => {
      const option = document.createElement('option');
      option.value = mesh;
      option.textContent = mesh;
      meshEl.appendChild(option);
    });

    renderAll();
  }

  function updateTopOptions() {
    showMessage('');

    const rule = getRule();
    const fix = fixEl.value;

    resetSelect(topEl, rule && fix ? I18N.choose : I18N.selectMeshFixFirst);
    topEl.disabled = !(rule && fix);

    resetSelect(materialEl, I18N.selectTopFirst);
    materialEl.disabled = true;

    if (!rule || !fix) {
      renderAll();
      return;
    }

    const options = getAvailableTopOptions(rule, fix);

    options.forEach((topKey) => {
      const option = document.createElement('option');
      option.value = topKey;
      option.textContent = TOP_LABELS[topKey] || topKey;
      topEl.appendChild(option);
    });

    if (options.length === 0) {
      resetSelect(topEl, I18N.noTop);
      topEl.disabled = true;
    }

    renderAll();
  }

  function updateMaterials() {
    showMessage('');

    const rule = getRule();
    const fix = fixEl.value;
    const selectedTop = topEl.value;

    resetSelect(materialEl, rule && fix && selectedTop ? I18N.choose : I18N.selectTopFirst);
    materialEl.disabled = !(rule && fix && selectedTop);

    if (!rule || !fix || !selectedTop) {
      renderAll();
      return;
    }

    const materials = getAvailableMaterials(rule, fix, selectedTop);

    materials.forEach((material) => {
      const option = document.createElement('option');
      option.value = material;
      option.textContent = MATERIAL_LABELS[material];
      materialEl.appendChild(option);
    });

    if (materials.length === 0) {
      resetSelect(materialEl, I18N.notAvailable);
      materialEl.disabled = true;
    }

    renderAll();
  }

  function describePart(partKey) {
    return PART_LABELS[partKey] || partKey;
  }

  function createPreviewRow(partKey, variantId, quantity) {
    return {
      partKey,
      variantId,
      quantity,
      label: describePart(partKey)
    };
  }

  function findMainProductMedia() {
    return (
      document.querySelector('media-gallery') ||
      document.querySelector('.product__media-wrapper') ||
      document.querySelector('.product__media-gallery') ||
      document.querySelector('.product-gallery')
    );
  }

  function ensurePreviewMediaHost() {
    if (previewMediaHost) return previewMediaHost;

    const mediaEl = findMainProductMedia();
    if (!mediaEl) return null;

    previewMediaOriginalChildren = Array.from(mediaEl.children);

    const host = document.createElement('div');
    host.id = 'gr-live-panel';
    host.style.display = 'none';
    host.style.width = '100%';
    host.style.background = '#fff';
    host.style.border = '2px solid #f3dfcf';
    host.style.borderRadius = '8px';
    host.style.padding = '24px';
    host.style.boxSizing = 'border-box';

    mediaEl.appendChild(host);
    previewMediaHost = host;

    return previewMediaHost;
  }

  function toggleMainProductMedia(hide) {
    const mediaEl = findMainProductMedia();
    const host = ensurePreviewMediaHost();

    if (!mediaEl || !host) return;

    previewMediaOriginalChildren.forEach((child) => {
      if (child !== host) {
        child.style.display = hide ? 'none' : '';
      }
    });

    host.style.display = hide ? 'block' : 'none';
  }

  function getPartImage(partKey) {
    const handle = PART_TO_HANDLE[partKey];
    if (!handle) return '';
    const product = productIndex[handle];
    if (!product) return '';
    return product.image || '';
  }

  function buildPartialItems(rule, fix, selectedTop, qty) {
    if (!rule || !fix || !qty || qty < 1) return [];

    const resolvedTop =
      selectedTop ||
      ((fix === 'holz_stellfuesse' ? rule.bohrTopOptions : rule.topOptions || []).length === 1
        ? (fix === 'holz_stellfuesse' ? rule.bohrTopOptions : rule.topOptions)[0]
        : null);

    if (!resolvedTop) return [];

    if (fix === 'holz_stellfuesse') {
      return [
        { partKey: resolvedTop, quantity: qty, label: describePart(resolvedTop) },
        { partKey: getBohrKey(rule.length), quantity: qty, label: describePart(getBohrKey(rule.length)) }
      ];
    }

    const screwKey = getScrewKey(resolvedTop, rule.length);

    if (fix === 'klemme') {
      return [
        { partKey: resolvedTop, quantity: qty, label: describePart(resolvedTop) },
        { partKey: screwKey, quantity: qty, label: describePart(screwKey) },
        { partKey: 'NUT_M8', quantity: qty, label: describePart('NUT_M8') },
        { partKey: rule.unterteilKlemme, quantity: qty, label: describePart(rule.unterteilKlemme) }
      ];
    }

    return [
      { partKey: resolvedTop, quantity: qty * 2, label: describePart(resolvedTop) },
      { partKey: screwKey, quantity: qty * 2, label: describePart(screwKey) },
      { partKey: 'NUT_M8', quantity: qty * 2, label: describePart('NUT_M8') },
      { partKey: rule.unterteilDoppelklemme, quantity: qty, label: describePart(rule.unterteilDoppelklemme) }
    ];
  }

  function buildPreviewItems(rule, selectedTop, material, fix, qty) {
    if (!rule || !selectedTop || !material || !fix || !qty || qty < 1) {
      return [];
    }

    if (fix === 'holz_stellfuesse') {
      const topId = getPartId(selectedTop, material);
      const bohrKey = getBohrKey(rule.length);
      const bohrId = getPartId(bohrKey, material);

      if (!topId || !bohrId) return [];

      return [
        createPreviewRow(selectedTop, topId, qty),
        createPreviewRow(bohrKey, bohrId, qty)
      ];
    }

    const screwKey = getScrewKey(selectedTop, rule.length);
    const topId = getPartId(selectedTop, material);
    const screwId = getPartId(screwKey, material);
    const nutId = getPartId('NUT_M8', material);

    if (!topId || !screwId || !nutId) return [];

    if (fix === 'klemme') {
      const underId = getPartId(rule.unterteilKlemme, material);
      if (!underId) return [];

      return [
        createPreviewRow(selectedTop, topId, qty),
        createPreviewRow(screwKey, screwId, qty),
        createPreviewRow('NUT_M8', nutId, qty),
        createPreviewRow(rule.unterteilKlemme, underId, qty)
      ];
    }

    const doubleId = getPartId(rule.unterteilDoppelklemme, material);
    if (!doubleId) return [];

    return [
      createPreviewRow(selectedTop, topId, qty * 2),
      createPreviewRow(screwKey, screwId, qty * 2),
      createPreviewRow('NUT_M8', nutId, qty * 2),
      createPreviewRow(rule.unterteilDoppelklemme, doubleId, qty)
    ];
  }

  function calculateSetAvailability(items, setQty) {
    if (!items.length || !setQty || setQty < 1) return null;

    let immediateSets = Infinity;
    let hasManagedInventory = false;
    let canOrderRequestedQty = true;

    items.forEach((item) => {
      if (!item.variantId || !item.quantity) return;

      const inventory = VARIANT_INVENTORY[String(item.variantId)];
      if (!inventory || inventory.inventory_management !== 'shopify') return;

      hasManagedInventory = true;

      const requiredPerSet = item.quantity / setQty;
      const availableQuantity = Math.max(0, parseInt(inventory.inventory_quantity, 10) || 0);
      const availableSetsForItem = Math.floor(availableQuantity / requiredPerSet);

      immediateSets = Math.min(immediateSets, availableSetsForItem);

      if (item.quantity > availableQuantity && inventory.inventory_policy !== 'continue') {
        canOrderRequestedQty = false;
      }
    });

    if (!hasManagedInventory || immediateSets === Infinity) return null;

    immediateSets = Math.max(0, immediateSets);

    return {
      immediateSets,
      backorderSets: Math.max(0, setQty - immediateSets),
      canOrderRequestedQty
    };
  }

  function getCurrentPreviewItems() {
    const type = typeEl.value;
    const mesh = meshEl.value;
    const fix = fixEl.value;
    const selectedTop = topEl.value;
    const material = materialEl.value;
    const qty = parseInt(qtyEl.value, 10);
    const rule = getRule();

    if (!type || !mesh || !fix || !selectedTop || !material || !qty || qty < 1 || !rule) {
      return { items: [], qty, rule };
    }

    return {
      items: buildPreviewItems(rule, selectedTop, material, fix, qty),
      qty,
      rule
    };
  }

  function formatSetCount(count) {
    return `${count} Stk`;
  }

  function renderAvailabilityNotice() {
    if (!availabilityEl) return;

    const { items, qty } = getCurrentPreviewItems();
    const availability = calculateSetAvailability(items, qty);

    availabilityEl.style.display = 'none';
    availabilityEl.textContent = '';

    if (!items.length || !availability) return;

    availabilityEl.style.display = 'block';

    availabilityEl.innerHTML =
      `<strong>${formatSetCount(availability.immediateSets)} verf\u00fcgbar.</strong><br>` +
      'Wenn mehr bestellt wird, erh\u00f6ht sich die Lieferzeit.';
  }

  function buildCartItems(rule, selectedTop, material, fix, qty, type, mesh) {
    const previewItems = buildPreviewItems(rule, selectedTop, material, fix, qty);
    const availability = calculateSetAvailability(previewItems, qty);

    const meta = {
      set_key: `${type}_${mesh}`,
      material,
      befestigung: fix,
      oberteil: selectedTop,
      konfigurator: 'gitterrost',
      _set_menge: qty
    };

    if (availability) {
      meta['Verf\u00fcgbar'] = `${availability.immediateSets} Stk`;
      meta['Lieferzeit'] = 'Wenn mehr bestellt wird, erh\u00f6ht sich die Lieferzeit.';
    }

    const cartItems = [];

    previewItems.forEach((item) => {
      const inventory = VARIANT_INVENTORY[String(item.variantId)] || {};
      const quantityRuleMax = parseInt(inventory.quantity_rule_max, 10);
      const maxPerLine =
        Number.isFinite(quantityRuleMax) && quantityRuleMax > 0 ? quantityRuleMax : item.quantity;
      let remainingQuantity = item.quantity;
      let splitIndex = 1;

      while (remainingQuantity > 0) {
        const lineQuantity = Math.min(remainingQuantity, maxPerLine);

        cartItems.push({
          id: item.variantId,
          quantity: lineQuantity,
          properties: {
            ...meta,
            _set_split: splitIndex
          }
        });

        remainingQuantity -= lineQuantity;
        splitIndex += 1;
      }
    });

    return cartItems;
  }

  async function loadProducts() {
    const handles = Array.from(new Set(Object.values(PART_TO_HANDLE)));

    try {
      const results = await Promise.all(
        handles.map(async (handle) => {
          const response = await fetch(`/products/${handle}.js`);
          if (!response.ok) {
            throw new Error(`Produktdaten konnten nicht geladen werden: ${handle}`);
          }
          return response.json();
        })
      );

      results.forEach((product) => {
        productIndex[product.handle] = {
          title: product.title,
          image: Array.isArray(product.images) && product.images.length ? product.images[0] : ''
        };

        product.variants.forEach((variant) => {
          variantIndex[String(variant.id)] = {
            title: product.title,
            variantTitle: variant.public_title,
            price: variant.price,
            image: Array.isArray(product.images) && product.images.length ? product.images[0] : ''
          };
        });
      });

      pricesLoaded = true;
      priceLoadFailed = false;
    } catch (error) {
      priceLoadFailed = true;
      console.error(error);
    } finally {
      renderLivePanel();
    }
  }

  function renderLivePanel() {
    const host = ensurePreviewMediaHost();
    if (!host) return;

    host.innerHTML = '';

    const type = typeEl.value;
    const mesh = meshEl.value;
    const fix = fixEl.value;
    const selectedTop = topEl.value;
    const material = materialEl.value;
    const qty = parseInt(qtyEl.value, 10);
    const rule = getRule();

    if (!type || !mesh || !fix || !qty || qty < 1 || !rule) {
      toggleMainProductMedia(false);
      return;
    }

    const exactItems =
      selectedTop && material ? buildPreviewItems(rule, selectedTop, material, fix, qty) : [];

    const partialItems = buildPartialItems(rule, fix, selectedTop, qty);
    const itemsToRender = exactItems.length ? exactItems : partialItems;

    if (!itemsToRender.length) {
      toggleMainProductMedia(false);
      return;
    }

    const header = document.createElement('div');
    header.style.marginBottom = '18px';

    const title = document.createElement('h2');
    title.textContent = I18N.summary;
    title.style.margin = '0 0 10px';
    title.style.fontSize = '32px';
    header.appendChild(title);

    const meta = document.createElement('div');
    meta.style.color = '#555';
    meta.style.lineHeight = '1.5';
    meta.textContent = `${type} · ${mesh}${fix ? ` · ${FIX_LABELS[fix] || fix}` : ''}${selectedTop ? ` · ${TOP_LABELS[selectedTop] || selectedTop}` : ''}${material ? ` · ${MATERIAL_LABELS[material] || material}` : ''} · ${I18N.qtyLabel} ${qty}`;
    header.appendChild(meta);

    host.appendChild(header);

    if (!pricesLoaded && !priceLoadFailed) {
      const loading = document.createElement('div');
      loading.textContent = I18N.loadingPrices;
      loading.style.marginBottom = '16px';
      host.appendChild(loading);
    }

    const grid = document.createElement('div');
    grid.style.display = 'grid';
    grid.style.gridTemplateColumns = 'repeat(2, minmax(0, 1fr))';
    grid.style.gap = '16px';

    let totalCents = 0;

    itemsToRender.forEach((item) => {
      const card = document.createElement('div');
      card.style.background = '#fff';
      card.style.border = '1px solid #eee';
      card.style.borderRadius = '8px';
      card.style.padding = '14px';
      card.style.textAlign = 'center';

      const imageUrl =
        item.partKey && getPartImage(item.partKey) ? getPartImage(item.partKey) : '';

      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = item.label;
        img.style.width = '100%';
        img.style.maxWidth = '180px';
        img.style.height = '140px';
        img.style.objectFit = 'contain';
        img.style.display = 'block';
        img.style.margin = '0 auto 10px';
        card.appendChild(img);
      }

      const itemTitle = document.createElement('div');
      itemTitle.textContent = item.label;
      itemTitle.style.fontWeight = '600';
      itemTitle.style.fontSize = '14px';
      itemTitle.style.marginBottom = '6px';
      card.appendChild(itemTitle);

      const qtyText = document.createElement('div');
      qtyText.textContent = `${item.quantity}x`;
      qtyText.style.color = '#666';
      qtyText.style.fontSize = '14px';
      qtyText.style.marginBottom = '6px';
      card.appendChild(qtyText);

      const variantData = item.variantId ? variantIndex[String(item.variantId)] : null;
      const unitPrice = variantData ? variantData.price : null;
      const rowTotal = unitPrice !== null ? unitPrice * item.quantity : null;

      if (rowTotal !== null) {
        totalCents += rowTotal;
      }

      const priceText = document.createElement('div');
      priceText.style.fontSize = '14px';
      priceText.style.fontWeight = '600';
      priceText.style.color = '#222';

      if (unitPrice !== null) {
        priceText.textContent = `${formatMoney(unitPrice)} · ${formatMoney(rowTotal)}`;
      } else {
        priceText.textContent = material ? '–' : '';
      }

      card.appendChild(priceText);
      grid.appendChild(card);
    });

    host.appendChild(grid);

    const footer = document.createElement('div');
    footer.style.marginTop = '20px';
    footer.style.paddingTop = '16px';
    footer.style.borderTop = '1px solid #eee';
    footer.style.display = 'flex';
    footer.style.justifyContent = 'space-between';
    footer.style.alignItems = 'center';
    footer.style.fontWeight = '700';
    footer.style.fontSize = '18px';

    const footerLabel = document.createElement('div');
    footerLabel.textContent = I18N.totalLabel;

    const footerValue = document.createElement('div');
    footerValue.textContent =
      pricesLoaded && !priceLoadFailed && material ? formatMoney(totalCents) : '–';

    footer.appendChild(footerLabel);
    footer.appendChild(footerValue);
    host.appendChild(footer);

    toggleMainProductMedia(true);
  }

  function renderRightSummary() {
    const type = typeEl.value;
    const mesh = meshEl.value;
    const fix = fixEl.value;
    const selectedTop = topEl.value;
    const material = materialEl.value;
    const qty = parseInt(qtyEl.value, 10);
    const rule = getRule();

    const summaryBodyEl = document.getElementById('gr-summary-body');
    const summaryTotalEl = document.getElementById('gr-summary-total');
    const summaryMetaEl = document.getElementById('gr-summary-meta');
    const summaryLoadingEl = document.getElementById('gr-summary-loading');
    const summaryEmptyEl = document.getElementById('gr-summary-empty');
    const summaryWrapEl = document.getElementById('gr-summary-table-wrap');

    if (!summaryBodyEl || !summaryTotalEl || !summaryMetaEl || !summaryLoadingEl || !summaryEmptyEl || !summaryWrapEl) {
      return;
    }

    summaryBodyEl.innerHTML = '';
    summaryTotalEl.textContent = '';
    summaryMetaEl.textContent = '';

    if (!type || !mesh || !fix || !selectedTop || !material || !qty || qty < 1 || !rule) {
      summaryWrapEl.style.display = 'none';
      summaryEmptyEl.style.display = 'block';
      summaryEmptyEl.textContent = I18N.selectConfiguration;
      return;
    }

    const previewItems = buildPreviewItems(rule, selectedTop, material, fix, qty);

    if (!previewItems.length) {
      summaryWrapEl.style.display = 'none';
      summaryEmptyEl.style.display = 'block';
      summaryEmptyEl.textContent = 'Für diese Kombination ist kein Set verfügbar.';
      return;
    }

    summaryEmptyEl.style.display = 'none';
    summaryWrapEl.style.display = 'block';

    summaryMetaEl.textContent =
      `${type} · ${mesh} · ${FIX_LABELS[fix] || fix} · ${TOP_LABELS[selectedTop] || selectedTop} · ${MATERIAL_LABELS[material] || material} · ${I18N.qtyLabel} ${qty}`;

    let totalCents = 0;

    previewItems.forEach((item) => {
      const variantData = variantIndex[String(item.variantId)];
      const unitPrice = variantData ? variantData.price : null;
      const rowTotal = unitPrice !== null ? unitPrice * item.quantity : null;
      if (rowTotal !== null) totalCents += rowTotal;

      const tr = document.createElement('tr');

      const nameTd = document.createElement('td');
      nameTd.style.padding = '8px 6px';
      nameTd.style.borderBottom = '1px solid #eee';
      nameTd.style.borderRight = '1px solid #ddd';
      nameTd.textContent = item.label;

      const qtyTd = document.createElement('td');
      qtyTd.style.padding = '8px 6px';
      qtyTd.style.borderBottom = '1px solid #eee';
      qtyTd.style.textAlign = 'right';
      qtyTd.textContent = item.quantity;

      tr.appendChild(nameTd);
      tr.appendChild(qtyTd);
      summaryBodyEl.appendChild(tr);
    });

    summaryTotalEl.textContent =
      pricesLoaded && !priceLoadFailed ? formatMoney(totalCents) : '…';
  }

  function renderAll() {
    renderAvailabilityNotice();
    renderLivePanel();
    renderRightSummary();
  }

  typeEl.addEventListener('change', updateMeshes);
  meshEl.addEventListener('change', updateTopOptions);
  fixEl.addEventListener('change', updateTopOptions);
  topEl.addEventListener('change', updateMaterials);
  materialEl.addEventListener('change', renderAll);
  qtyEl.addEventListener('input', renderAll);

  addEl.addEventListener('click', async () => {
  try {
    const type = typeEl.value;
    const mesh = meshEl.value;
    const fix = fixEl.value;
    const selectedTop = topEl.value;
    const material = materialEl.value;
    const qty = parseInt(qtyEl.value, 10);

    if (!type || !mesh || !fix || !selectedTop || !material || !qty || qty < 1) {
      showMessage('Bitte alles auswählen', true);
      return;
    }

    const rule = CONFIG[`${type}_${mesh}`];
    if (!rule) {
      showMessage('Kombination nicht verfügbar', true);
      return;
    }

    const items = buildCartItems(rule, selectedTop, material, fix, qty, type, mesh);

    if (!items.length) {
      showMessage('Für diese Kombination konnten keine Artikel ermittelt werden.', true);
      return;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.description || data?.message || 'Artikel konnten nicht in den Warenkorb gelegt werden.');
    }

    showMessage('Set wurde hinzugefügt.');
  } catch (err) {
    console.error(err);
    showMessage(err.message, true);
  }
});

  renderLivePanel();
  renderRightSummary();
  renderAvailabilityNotice();
  updateMeshes();
  loadProducts();
});
